import type { AABB, Faction } from '../game/ontology';

// Hurtbox — the defensive AABB an Actor exposes to be hit. On a resolved hit it
// fires `onHit`, which the Actor wires to play its reaction (`hit`) Loop. A brief
// invulnerability window after each hit stops a lingering overlap from
// re-triggering every frame.

let nextId = 1;

export class Hurtbox {
  readonly id: number = nextId++;
  readonly faction: Faction;
  readonly ownerId: number;
  /** Live world-space AABB, refreshed each frame by the owner. */
  box: AABB;
  /** Seconds of remaining invulnerability. */
  private invuln = 0;
  private readonly invulnDuration: number;

  /** Called once per resolved hit. The Actor plays its reaction Loop here. */
  onHit: (from: { faction: Faction; ownerId: number }) => void = () => {};

  constructor(ownerId: number, faction: Faction, box: AABB, invulnDuration = 0.4) {
    this.ownerId = ownerId;
    this.faction = faction;
    this.box = box;
    this.invulnDuration = invulnDuration;
  }

  get vulnerable(): boolean {
    return this.invuln <= 0;
  }

  /** Register a hit: start invulnerability and notify the owner. */
  takeHit(from: { faction: Faction; ownerId: number }): void {
    this.invuln = this.invulnDuration;
    this.onHit(from);
  }

  update(dtSec: number): void {
    if (this.invuln > 0) this.invuln = Math.max(0, this.invuln - dtSec);
  }
}
